// extracted by mini-css-extract-plugin
export default {"root":"ActionItemInner_root__ZHM1Q","icon":"ActionItemInner_icon__IXojY"};